// import Plyr from 'plyr';

/*
<button type="button" class="plyr__control" data-plyr="restart">
<span class="visually-hidden">restart</span>
<svg role="presentation"><use xlink:href="#plyr-restart"></use></svg>
<span class="plyr__tooltip" role="tooltip">Restart</span>
</button>
<button type="button" class="plyr__control" data-plyr="rewind">
<span class="visually-hidden">rewind</span>
<svg role="presentation"><use xlink:href="#plyr-rewind"></use></svg>
<span class="plyr__tooltip" role="tooltip">Rewind {seektime} secs</span>
</button>
<div class="plyr__time plyr__time--duration plyr__control" aria-label="Duration">00:00</div>-->
<button type="button" class="plyr__control" data-plyr="fast-forward">
    <svg role="presentation"><use xlink:href="#plyr-fast-forward"></use></svg>
    <span class="plyr__tooltip" role="tooltip">Forward {seektime} secs</span>
</button>
<div class="plyr__volume">
    <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
</div>
<span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
<span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
*/

export default () => {
  const controls = `
    <div class="plyr__controls" style="">
        <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
            <span class="visually-hidden">play</span>
            <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
            <!-- <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
            <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>-->
        </button>
        <div class="plyr__time plyr__time--current plyr__control" aria-label="Current time">00:00</div>
        <div class="plyr__progress" style="">
            <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
            <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
            <span role="tooltip" class="plyr__tooltip">00:00</span>
        </div>
        <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
            <span class="visually-hidden">mute</span>
            <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
            <!-- <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
            <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>-->
        </button>

        <button type="button" class="plyr__control" data-plyr="captions">
            <span class="visually-hidden">captions</span>
            <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-captions-on"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-captions-off"></use></svg>
            <span class="label--pressed plyr__tooltip" role="tooltip">Disable captions</span>
            <span class="label--not-pressed plyr__tooltip" role="tooltip">Enable captions</span>
        </button>
        <button type="button" class="plyr__control" data-plyr="fullscreen">
            <span class="visually-hidden">fullscreen</span>
            <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
        </button>
    </div>
  `;

  window.player = new Plyr('#player', {
    controls,
  });

  $(document).on('click tap', '#overlay_play', () => {
    $('.plyr-heading').toggle();
    window.player.play();
  });
};
